import React, { Fragment, useState, useEffect } from 'react';

import Bars from './Bars';
import './Bars.scss';

const sortByCorrectAnswers = ({ ascending }) => {
  if (ascending) {
    return (a, b) => {
      if (b.correctAnswersGiven < a.correctAnswersGiven) {
        return -1;
      }
      if (b.correctAnswersGiven > a.correctAnswersGiven) {
        return 1;
      }
      return b.order === a.order ? 0 : b.order > a.order ? -1 : 1;
    };
  }
  return (a, b) => {
    if (b.correctAnswersGiven > a.correctAnswersGiven) {
      return -1;
    }
    if (b.correctAnswersGiven < a.correctAnswersGiven) {
      return 1;
    }
    return b.order === a.order ? 0 : b.order > a.order ? -1 : 1;
  };
};

const BarsContainer = ({
  barsData,
  denominator,
  amountOfBars = 3,
  doubleBar = false,
  percentStyleClass = 'blue-background',
  comparisonStyleClass = 'light-blue-background',
  hasComparisonPercentages = false,
}) => {
  const [highest, setHighest] = useState(null);
  const [lowest, setLowest] = useState(null);
  const [allData, setAllData] = useState([]);

  const colorClasses = {
    percentStyleClass,
    comparisonStyleClass,
  };

  const barModel = (question) => ({
    title: `${question.comparisonPercentage !== undefined ? 'Question ' : 'Q.'}${parseInt(question.order, 10) + 1}`,
    percent: question.questionPercentage,
    comparisonPercentage: question.comparisonPercentage,
    showPopover: question.showPopover,
    ...(question.questionLOs
      ? {
          popoverContent: (
            <div>
              <p className="standard-popup-title">Learning Objective(s)</p>
              {question.questionLOs.map((lo) => (
                <p className="standard-popup-content" key={lo.internal_name}>
                  {lo.description}
                </p>
              ))}
            </div>
          ),
        }
      : {}),
  });

  useEffect(() => {
    if (barsData && denominator) {
      const barsDataHigh = [...barsData];
      const barsDataLow = [...barsData];
      const highestBars = barsDataHigh
        .sort(sortByCorrectAnswers({ ascending: true }))
        .slice(0, amountOfBars);
      const lowestBars = barsDataLow
        .sort(sortByCorrectAnswers({ ascending: false }))
        .slice(0, amountOfBars);

      setHighest(highestBars.map(barModel));
      setLowest(lowestBars.map(barModel));
      if (doubleBar) {
        setAllData(barsData.map(barModel));
      }
    }
  }, [barsData]);

  return doubleBar ? (
    <Bars
      label={null}
      barsData={allData}
      doubleBar={doubleBar}
      hasComparisonPercentages={hasComparisonPercentages}
      {...colorClasses}
    />
  ) : (
    highest && lowest && (
      <Fragment>
        <Bars
          label="Highest Performing"
          barsData={highest}
          hasComparisonPercentages={hasComparisonPercentages}
          {...colorClasses}
        />
        <Bars
          label="Lowest Performing"
          barsData={lowest}
          hasComparisonPercentages={hasComparisonPercentages}
          {...colorClasses}
        />
      </Fragment>
    )
  );
};

export default BarsContainer;
